import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod/v4";

export const listProducts = {
  name: "listProducts" as const,
  input: z.object({
    products: z.array(
      z.object({
        productFamilyId: z.string().optional(),
        productId: z.string(),
        variantId: z.string(),
        quantity: z.number().min(1),
        price: z.number().optional(),
        description: z.string().optional(),
      }),
    ),
    channels: z.array(ChannelSchema).min(1),
  }),

  output: z.object({
    results: z.array(
      z.object({
        channel: ChannelSchema,
        success: z.boolean(),
        catalogProductId: z.string().optional(),
        listingId: z.string().optional(),
        listingUrl: z.string().optional(),
        error: z.string().optional(),
      }),
    ),
  }),
};
